export enum ReportStatus {
  NotStarted = 'not_started',
  InProgress = 'in_progress',
  Inspected = 'inspected',
  CannotInspect = 'cannot_inspect',
  NotPresent = 'not_present',
}

export enum ReportSeverityType {
  monitor = 'monitor',
  repair = 'repair',
  safety = 'safety',
  inspectify_flag = 'inspectify_flag',
}

export enum ReportApplianceStatus {
  PendingData = 'pending_data',
  Source7Ready = 'source7_ready',
  Source7Retrieved = 'source7_retrieved',
  Source7Verified = 'source7_verified',
  InspectorSkipped = 'inspector_skipped',
  InspectorVerified = 'inspector_verified',
  InspectifyFixed = 'inspectify_fixed',
}

export enum ReInspectionStatus {
  Fixed = 'fixed',
  StillExists = 'still_exists',
}

export enum DeficiencyRecommendationType {
  Evaluation = 'evaluation',
  RepairReplace = 'repair_or_replace',
  Monitor = 'monitor',
}

export enum CannotAnswerReason {
  NotPresent = 'not_present',
  NoAccess = 'no_access',
  Other = 'other',
}

export enum ReportOrientationType {
  any = 'any_orientation',
  portrait = 'portrait',
  landscape = 'landscape',
}

export enum ReportMediaType {
  any = 'any_media_type',
  video = 'video',
  photo = 'photo',
  sphere = 'photo_sphere',
}

export enum ReportItemType {
  System = 'ReportSystem',
  Subsystem = 'ReportSubsystem',
  ApplianceInformation = 'ReportApplianceInformation',
  Information = 'ReportInformation',
  Deficiency = 'ReportDeficiency',
  Limitation = 'ReportLimitation',
  Attachment = 'ReportAttachment',
  Location = 'ReportLocation',
}

export enum ReportInformationStatus {
  Incomplete = 'incomplete',
  Completed = 'completed',
  CannotAnswer = 'cannot_answer',
}
